/**
 * View imports
 */
import {HomeComponent} from "./components/home.component";
import {IndexCampaignsComponent} from "./components/campaigns/index/index_campaigns.component";
import {NewCampaignComponent} from "./components/campaigns/new/new_campaign.component";
import {EditCampaignComponent} from "./components/campaigns/edit/edit_campaign.component";
import {IndexVouchersComponent} from "./components/vouchers/index/index_vouchers.component";
import {ShowCampaignComponent} from "./components/campaigns/show/show_campaign.component";
import {ShowVoucherComponent} from "./components/vouchers/show/show_voucher.component";

/*
    Routes are defined here.
 */

export class Routes {
    public static configure() {

        return [
            {path: '/', name: 'Home', component: HomeComponent, useAsDefault: true},
            {path: '/campaigns', name: 'Campaigns', component: IndexCampaignsComponent},
            {path: '/campaigns/new', name: 'NewCampaign', component: NewCampaignComponent},
            {path: '/campaigns/:campaignId/edit', name: 'EditCampaign', component: EditCampaignComponent},
            {path: '/campaigns/:campaignId', name: 'Campaign', component: ShowCampaignComponent},
            {path: '/campaigns/:campaignId/vouchers', name: 'Vouchers', component: IndexVouchersComponent},
            {path: '/campaigns/:campaignId/vouchers/:voucherCode', name: 'Voucher', component: ShowVoucherComponent}
        ];
    }
}
